import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DatevWizardState} from '../../+store/datev-wizard.state';
import {DatevWizardCaseSelectionState} from './datev-wizard-case-selection.state';

/**
 * DatevWizardCaseSelectionSelectors
 *
 * Selektoren für den Case-Selection State.
 */
export class DatevWizardCaseSelectionSelectors {
  private static readonly _feature = createFeatureSelector<DatevWizardState>('wizard');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DatevWizardCaseSelectionState => state.datevWizardCaseSelection,
  );

  /**
   * Selector für den gewählten Export-Fall.
   * Gibt 'fall1', 'fall2' oder undefined zurück.
   */
  public static readonly selectedCase = createSelector(
    this._slice,
    (state) => state.selectedCase,
  );
}
